/*
 * @Author: cryi.liu
 * @Date: 2020-06-04 09:58:48
 * @LastEditTime: 2020-06-09 16:09:42
 * @Description: 工具类视图路由
 */

const prefix = '';

export default [
  {
    name: 'PdfPreview',
    path: `${prefix}/tools/preview/pdf/:url`,
    component: () => import(/* webpackChunkName: "examQuestionLibrary" */'../../views/tools/preview/pdf/Index.vue'),
    props: true,
    meta: {
      page: 'pdf预览',
      layout: '',
    },
  },
];
